<template>
  <div class="field">
    <label class="mb-2 block"><strong>{{ titulo || 'SELECCIONE BORDES' }}</strong></label>
    <div v-if="cargando" class="flex align-items-center">
      <i class="pi pi-spin pi-spinner mr-2 text-primary"></i> Cargando bordes...
    </div>
    <div v-else class="flex flex-column gap-2 mt-2">
      <div v-for="borde in bordes" :key="borde.id" class="flex align-items-center">
        <Checkbox 
          v-model="seleccionados" 
          :inputId="'borde_' + borde.id" 
          name="borde" 
          :value="borde" 
          @change="emitirCambio"
        />
        <label :for="'borde_' + borde.id" class="ml-2 mb-0 cursor-pointer text-700">
          {{ borde.nombre }} 
          <span v-if="borde.precio_venta > 0" class="text-green-600 font-bold ml-1">
            (Bs. {{ borde.precio_venta }})
          </span>
        </label>
      </div>
      <div v-if="bordes.length === 0" class="text-500 font-italic">
        No hay bordes disponibles o activos.
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/service/ProductService';

// Variables de caché a nivel de módulo para evitar múltiples peticiones en la misma sesión
let cachedBordes = null;
let fetchingBordesPromise = null;

export default {
  name: 'CheckBordes',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    sucursalId: {
      type: [Number, String],
      default: 1
    },
    titulo: {
      type: String,
      default: 'SELECCIONE BORDES EXTRAS'
    }
  },
  data() {
    return {
      bordes: [],
      seleccionados: [],
      cargando: false,
      productService: null
    };
  },
  created() {
    this.productService = new ProductService();
    this.seleccionados = [...this.modelValue];
  },
  mounted() {
    this.cargarBordes();
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.seleccionados = [...newVal];
      },
      deep: true
    },
    sucursalId() {
      // Si cambia de sucursal forzamos recarga
      cachedBordes = null;
      fetchingBordesPromise = null;
      this.cargarBordes();
    }
  },
  methods: {
    cargarBordes() {
      if (cachedBordes) {
        this.bordes = cachedBordes;
        return;
      }

      if (fetchingBordesPromise) {
        this.cargando = true;
        fetchingBordesPromise.then(bordes => {
          this.bordes = bordes;
          this.cargando = false;
        });
        return;
      }

      this.cargando = true;
      fetchingBordesPromise = this.productService.getBordes(this.sucursalId).then(response => {
        cachedBordes = response.productos || [];
        this.bordes = cachedBordes;
        return cachedBordes;
      }).catch(err => {
        console.error("Error al cargar bordes:", err);
        fetchingBordesPromise = null;
        return [];
      }).finally(() => {
        this.cargando = false;
      });
    },
    emitirCambio() {
      this.$emit('update:modelValue', this.seleccionados);
      this.$emit('change', this.seleccionados);
    }
  }
}
</script>

<style scoped>
</style>
